<script>
export default {
  name: "NotFound",
  props: ["notfound"],
  computed: {
    title() { return this.notfound.Title },
    descr() { return this.notfound.Description },
  },
}
</script>

<template>
  <div
    id="notfound"
    aria-label="The not-found quadrant"
    tabindex="0"
    class="fallback"
  >
    <!-- <p tabindex="0"><span> {{ title }} </span></p> -->
    <!-- <p tabindex="0"><span> {{ descr }} </span></p> -->
  </div>
</template>

<style scoped>
#notfound {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
}
</style>
